import Vue from "vue";
import Router from "vue-router";
import VueGtm from "@bend-financial/vue2-gtm";
import { UserOnboardingSteps } from "@/shared/types";
import { getEnvironment, Environment } from "@/shared/env";
import { useWizardStore } from "@/employee/store/wizard";
import { useUserStore } from "@/shared/store/user";
import { isMobileApp } from "@/shared/mobileHelper";
import firebaseAnalytics  from "@/shared/firebaseAnalytics";
import { AuthFactory } from "./api/auth";

export function registerGtm (router: Router) {
    const isProd = getEnvironment() === Environment.Prod;

    if (isMobileApp()) {
        Vue.use(firebaseAnalytics, {
            vueRouter: router
        });
    } else {
        Vue.use(VueGtm, {
            id: isProd ? "GTM-M567KS4" : "GTM-5PFGXCQ",
            debug: !isProd,
            vueRouter: router,
            vueRouterAdditionalEventData: (): Record<string, any> => (cognitoUsernamePromise())
        });
    }
}

export async function cognitoUsernamePromise (): Promise<Record<string, any>> {
  const user = await AuthFactory.getAuth().getUser();
  return { cognitoUsername: user.username };
}

const mutationLookup = {

    wizard_setStepComplete () {

        const wizardStore = useWizardStore();
        const currentStepStatus = wizardStore.onboardingWizard.statuses.find(s => s.complete === false);
        const currentStep = currentStepStatus ? currentStepStatus.step - 1 : null;

        return {
            "wizard-step": currentStep ? currentStep : UserOnboardingSteps.Finish
        };
    }
};

export function gtmPlugin () {

    const vue = Vue;
    const wizardStore = useWizardStore();
    wizardStore.$subscribe((m, state) => {
      try {
            const mutation = m.type.replace(`/`, `_`);
            const payload = mutationLookup[mutation] && mutationLookup[mutation]();

            if (payload) {
                const base = {};

                const userStore = useUserStore();
                if (userStore.site) {
                    base[`portal`] = userStore.site[0].toUpperCase() + userStore.site.substr(1).toLowerCase();
                }

                if (userStore.accountType) {
                    base[`account-type`] = userStore.accountType[0].toUpperCase() +
                        userStore.accountType.substr(1).toLowerCase();
                }

                vue.prototype.$gtm.trackEvent({
                    event: `mutation`,
                    noninteraction: mutation,
                    ...base,
                    ...payload
                });
            }

        } catch (e) {
            throw new Error(`Error with pinia-gtm plugin: ${e}`);
        }
    });
}